import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CacheInterceptor } from './cache.interceptor';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { HttpHeadersInterceptor } from './http-headers.interceptor';
import { RedirectToLocalInterceptor } from './redirect-to-local.interceptor';
import { TenantInterceptor } from './tenant.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TenantInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: RedirectToLocalInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpHeadersInterceptor, multi: true },
];

export { inSkipList } from './skip-list';
